var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.953,
    height: 31,
    viewBox: "0 0 28.953 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:var(--primary-color);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.158 432)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M168.4-431.864a2.494,2.494,0,0,0-1.105,1.105l-.172.373L167.1-423.5c-.022,7.563-.029,7.4.416,8.037a2.173,2.173,0,0,0,1.249.84,5.084,5.084,0,0,0,1.055.05,2.169,2.169,0,0,0,1.744-.71c.581-.646.545-.158.545-7.994,0-7.858.036-7.348-.56-8.008-.524-.588-.868-.71-1.952-.71A2.789,2.789,0,0,0,168.4-431.864Z",
    transform: "translate(-154.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.481-378.809a7.79,7.79,0,0,0-.818.481,14.492,14.492,0,0,0-5.081,5.805,14.231,14.231,0,0,0-1.414,6.839,14.526,14.526,0,0,0,1.442,5.956,13.5,13.5,0,0,0,6.53,6.53,14.354,14.354,0,0,0,6.5,1.471,13.373,13.373,0,0,0,6.229-1.4,14.322,14.322,0,0,0,6.76-6.674,14.761,14.761,0,0,0,1-10.19,14.016,14.016,0,0,0-6.308-8.568c-.61-.366-.832-.431-1.091-.294-.129.072-.136.172-.136,1.966V-375l.631.538a10.508,10.508,0,0,1,3.645,6.9,11.805,11.805,0,0,1-.115,3.516,10.7,10.7,0,0,1-7.305,8.152,9.62,9.62,0,0,1-3.351.524,10.5,10.5,0,0,1-10.19-7.154,9.393,9.393,0,0,1-.567-3.631,8.517,8.517,0,0,1,.165-2.153,10.849,10.849,0,0,1,3.538-6.071l.631-.538V-376.8a7.464,7.464,0,0,0-.086-1.959A.59.59,0,0,0,7.481-378.809Z",
    transform: "translate(0 -49.273)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.304d513e.svg";
export { ForwardRef as ReactComponent };